<template>
  <div v-if="type===1" class="aoform__step" :class="{'aoform__step_hidden': hideCondition}">
    <h2 class="aoform__title aoform__title_altspace">Подтверждение и оплата</h2>
    <p class="aoform__subtitle">Введите код из смс, чтобы подтвердить договор и{{'\xa0'}}перейти{{'\xa0'}}к{{'\xa0'}}оплате</p>
    <NumberInput name='code' text='ВВЕДИТЕ КОД ИЗ СМС-СООБЩЕНИЯ' mask='####' v-model="code"/>
    <Filler />
    <FormBtn disabled :nodecor="true" :toright="true"
             v-if="this.count">Получить повторный код через {{this.count}} сек.</FormBtn>
    <FormBtn :nodecor="true" v-if="!this.count"
             @click.native="()=>sendSMS(true)" :toright="true">
             <span class="aoform__btn-underlined">
             Получить код ещё раз</span></FormBtn>
  </div>
  <div v-else-if="type===2" class="aoform__step" :class="{'aoform__step_hidden': hideCondition}">
    <h2 class="aoform__title aoform__title_altspace">Подтверждение и оплата</h2>
    <p class="aoform__subtitle">Вы успешно подтвердили свой номер и подписали полис. Перейдите по ссылке для оплаты.</p>
    <BtnContainer>
        <FormBtn :disabled="block" @click.native="goPayLink">Оплатить</FormBtn>
    </BtnContainer>
</div>
    <div v-else-if="type===3" class="aoform__step" :class="{'aoform__step_hidden': hideCondition}">
        <h2 class="aoform__title aoform__title_altspace">Подтверждение и оплата</h2>
        <p class="aoform__subtitle">Вы успешно подтвердили свой номер и подписали полис. Перейдите по ссылке для оплаты.</p>
        <BtnContainer>
            <FormBtn :disabled="block" @click.native="goPayLink">Еще раз</FormBtn>
        </BtnContainer>
    </div>
</template>

<script>
import FormTitles from '@/mixins/FormTitles.vue'
import FormBtn from '@/components/FormBtn.vue'
import BtnContainer from '@/components/BtnContainer.vue'
import Filler from '@/components/Filler.vue'
import NumberInput from '@/components/NumberInput.vue'
import axios from "axios";
import config from "../config";
export default {
  components: { FormBtn,BtnContainer, Filler, NumberInput },
  mixins: [FormTitles],
  props: {
    hideCondition: {type: Boolean, required: true}
  },
  data: ()=>({
    type: 1,
    payLink: undefined,
    code: '',
    block: false,
    verified: false,
    timer: undefined,
    count: 0,
  }),
  methods:{
      goPayLink(){

          //console.log(this.payLink);
          let vm = this;
          vm.block = true;
          vm.$store.commit('setLoading', true)
          var newWindow = window.open()
          axios.post(config.apiPath + config.path.payReceive, { formData: vm.$store.state.client, selectedProgram: vm.$store.state.selectedProgram }).then(response => {
              vm.$store.commit('setLoading', false)

              if( response.data.status !== undefined && response.data.status === "OK" && response.data.link !== undefined ) {
                  this.type = 3;
                  this.payLink = response.data.link;
                  newWindow.location = this.payLink
                  vm.block = false;
              }
              else if (response.data.status !== undefined && response.data.status === "ERROR"){
                  this.$store.commit('customErrorText',  response.data.messages)
                  this.$store.commit('throwError')
                  vm.block = false;
                  newWindow.close()
              }
              else{
                  this.$store.commit('customErrorText', [])
                  this.$store.commit('throwError')
                  vm.block = false;
                  newWindow.close()
              }
          }).catch(()=> {
              this.$store.commit('setLoading', false)
              this.$store.commit('customErrorText', [])
              this.$store.commit('throwError')
              this.type = 3;
              newWindow.close()
              vm.block = false;
          });
      },
    sendSMS(repeat)
    {
        if (repeat) 
          document.dispatchEvent(new Event('ym-sms_repeat'))
                  //if (!this.clientPhoneNumber)
          //return this.$store.commit('throwError')
        let vm = this;
        vm.block = true;
        vm.$store.commit('setLoading', true)
        axios.post(config.apiPath + config.path.getCode).then(response => {
            // eslint-disable-next-line no-empty
            vm.$store.commit('setLoading', false)
            if( response.data.status !== undefined && response.data.status === "OK" ) {
                vm.block = false
            }
            else if (response.data.status !== undefined && response.data.status === "ERROR"){
                this.$store.commit('customErrorText',  response.data.messages)
                this.$store.commit('throwError')
                vm.block = false
            }
            else{
                this.$store.commit('customErrorText', [])
                this.$store.commit('throwError')
                vm.block = false
            }
        }).catch(()=> {
            this.$store.commit('setLoading', false)
            this.$store.commit('customErrorText', [])
            this.$store.commit('throwError')
            vm.block = false

        });

      this.count = 59
      this.timer = setInterval(()=>{
        this.count--
        if (this.count == 0) 
          clearInterval(this.timer)
      }, 1000)
    },
    checkCode(){

        let vm = this;
        console.log(vm.block);
        if(!vm.block){
            let code = this.code;
            if(code.length == 4) {
              vm.block = true;
              vm.$store.commit('setLoading', true)
              axios.post(config.apiPath + config.path.confirmCode, {code : code, formData: vm.$store.state.client, selectedProgram: vm.$store.state.selectedProgram }).then(response => {
                  vm.$store.commit('setLoading', false)
                  // eslint-disable-next-line no-empty
                  if( response.data.status !== undefined && response.data.status === "OK" ){//&& response.data.link !== undefined ) {
                      this.type = 2;
                      this.payLink = response.data.link;
                      vm.block = false
                  }
                  else if (response.data.status !== undefined && response.data.status === "ERROR"){
                      this.$store.commit('customErrorText',  response.data.messages)
                      this.$store.commit('throwError')
                      vm.block = false
                  }
                  else{
                      this.$store.commit('customErrorText', [])
                      this.$store.commit('throwError')
                      vm.block = false
                  }
              }).catch(()=> {
                  this.$store.commit('setLoading', false)
                  this.$store.commit('customErrorText', [])
                  this.$store.commit('throwError')
                  vm.block = false

              });
              this.verified = true
              document.dispatchEvent(new Event('ym-sms_ok'))
          }
            else {
              this.verified = false
            }
        }
      }
  },
  computed:{
    clientPhoneNumber(){
      return this.$store.state.clientPhoneNumber
    },
    step(){
      return this.$store.state.step
    }
  },
  watch: {
    step(val){
      if (val == 3 && !this.count)
        this.sendSMS()
    },
    code(){
      this.checkCode()
    }
  }
}
</script>

<style>

</style>